// extracted by mini-css-extract-plugin
module.exports = {"freeShippingContainer":"az_khc","freeDelivery":"az_lhc","freeShippingContainerBorder":"az_mhc"};